import { Customer } from '@app/shared/sdk/models';
import { Area } from '@app/shared/sdk/models';

import { TranslateService } from '@ngx-translate/core';

export interface ContextInterface {
  customer: Customer;
  area: Area;
  language: string;
}

export class Context implements ContextInterface {
  customer: Customer;
  area: Area;
  language: string;

  constructor(data?: ContextInterface) {
    Object.assign(this, data);
  }

  public static getModelName() {
    return "Context";
  }

  public static factory(data: ContextInterface): Context {
    return new Context(data);
  }
}
